import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CloNotifications, CloNotificationItem} from './notifications';

export {CloNotificationItem, CloNotifications} from './notifications';

@NgModule({
  declarations: [CloNotifications, CloNotificationItem],
  exports: [CloNotifications, CloNotificationItem],
  imports: [CommonModule],
  entryComponents: [CloNotifications]
})
export class CloNotificationsModule {
}
